function normalizeApiBase(value) {
  const base = String(value || '').trim().replace(/\/+$/, '')
  return base || '/app'
}

export const API_BASE = normalizeApiBase(
  import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_APP_API_BASE || '/app'
)
